import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { ApiServiceService } from '@shared/services/api-service/api-service.service';

@Injectable({
  providedIn: 'root'
})

export class ProcessResolver  {
    constructor(private apiService: ApiServiceService) { }

    resolve(route: ActivatedRouteSnapshot) {
      return this.apiService.get('processes', route.params['evaluationId']+'/'+route.params['conceptId'])
        .then((data:any)=>{
          return data
        })
    }
}
